<template>
  <div :class="['activate-table-license-component text-left flex', stylingClasses]">
    <div class="inline w-[22px] h-[22px]">
      <img v-if="isLicenseLocked"
        src="@/static/icons/lock_solid_black.svg"
        class="table-license-icon-locked h-full w-full">
      <img v-if="isLicenseOk"
        src="@/static/icons/check_solid_black.svg"
        class="table-license-icon-locked h-full w-[14px] mx-auto block">
    </div>

    <div class="pl-[3px] pt-[2px]">
      <span v-if="isWidgetLicenseType" class="table-license-text-widgets text-[#034B8A]">{{ 'WIDGETS' }}</span>
      <span v-else-if="isKioskLicenseType" class="table-license-text-kiosk text-[#1B998B]">{{ 'KIOSK' }}</span>
      <span v-else-if="isSystemsLicenseType" class="table-license-status-systems text-[#ED215B]">{{ 'SYSTEMS' }}</span>
    </div>
  </div>
</template>

<script src="./table-column-label-with-icon.js"></script>
